module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Marquee Tiles',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'NO',
      show: 'Active',
      title: 'TITLE',
      link: 'DEEP LINK TYPE',
      partner: 'PARTNER',
      status: 'STATUS',
      action: 'ACTION',
      country: 'COUNTRY',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
      schedule: 'Schedule',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Marquee Tile?',
      edit: 'Are you sure to edit this Marquee Tile?',
      enable: 'Are you sure you want to enable this Marquee Tile?',
      disable: 'Are you sure you want to disable this Marquee Tile?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    image3x4: 'Please upload a 4x3 image or a video',
    imageUpload: '*Upload an image',
    title: 'Title',
    subTitle: 'Subtitle',
    link: 'Link',
    linkType: 'Page Type',
    countries: 'Countries',
    btnUpdateProductTile: 'Update',
    btnCreateProductTile: 'Add',
    scheduleTile: 'Schedule Marquee Tile',
    updateProductTile: 'Edit Marquee Tile',
    createProductTile: 'Add Marquee Tile',
    backgroundColor: 'Background Color',
    titleColor: 'Title Color',
    subColor: 'Subtitle Color',
    cta: 'CTA',
    ctaTextColor: 'CTA Text Color',
    ctaBackgroundColor: 'CTA Background Color',
    btnSubmit: 'Submit',
  },
  validate: {
    titleBlank: 'Please input title!',
    countryBlank: 'Please select country!',
    linkBlank: 'Please input a link!',
    linkTypeBlank: 'Please select page type!',
    imageBlank: 'Please input an image or video!',
    ctaBlank: 'Please input a CTA!',
  },
  tab: {
    detail: {
      form: {
        time: {
          title: 'Time',
          startTimePlaceholder: 'Start time',
          endTimePlaceholder: 'End time',
          startDatePlaceholder: 'Start date',
          endDatePlaceholder: 'End date',
        },
        validate: {
          titleBlank: 'Please input title.',
          countryBlank: 'Please select Country',
          descriptionBlank: 'Please input description.',
          startBeforeNow: 'The start date time must be after now.',
          endBeforeNow: 'The end date time must be after now.',
          startBeforeEnd: 'The start date must be before the end date time.',
          startTimeBlank: 'Please input start time.',
          endTimeBlank: 'Please input end time.',
          startDateBlank: 'Please input start date.',
          endDateBlank: 'Please input end date.',
          productNameBlank: 'Please input product name.',
          productDescriptionBlank: 'Please input product description.',
          productVideoTypeBlank: 'Please input product video type.',
          productVideoIdBlank: 'Please input product video id.',
          frequencyBlank: 'Please input push notifications reminder frequency.',
        },
      },
    },
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image.',
      maxItem: 'Please disable another tile before enabling a new one.',
    },
    success: {
      updateProductTile: 'Marquee Tile successfully updated.',
      createProductTile: 'Marquee Tile successfully added.',
      scheduleTile: 'Marquee Tile successfully scheduled.',
      deleteProductTile: 'Marquee Tile successfully deleted.',
    },
  },
};
